module.exports = __webpack_public_path__ + "img/bj.9ec46b3a.svg";